import { ROUTES } from "../../../routes.js";
import { useSparkContext } from "../context/SparkContext.jsx";
import { SparkOverviewWithData } from "./SparkOverviewWithData.jsx";

/**
 * Represents a component that displays an overview of a Spark within a workshop.
 * This component mainly takes care of gathering the data, which it then fills into
 * another component to display.
 *
 * @returns The rendered SparkOverview component.
 */
const SparkOverview = () => {
  const { workshop, spark, structure } = useSparkContext();

  if (!structure || structure.length === 0) {
    return <p>Lernreise hat noch keine Inhalte.</p>;
  }

  return (
    <SparkOverviewWithData
      baseUrl={ROUTES.spark.getUrl({
        workshopSlug: workshop.slug,
        sparkSlug: spark.slug,
      })}
      sparkSlug={spark.slug}
      phases={structure}
      templateTitle={spark.inAppTitle}
    />
  );
};

export default SparkOverview;
